var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.valueExists && _vm.value !== 0)?_c('span',[(_vm.value > 0)?_c('span',{staticClass:"increase"},[_vm._v("(+"+_vm._s(_vm.value)+")")]):_c('span',{staticClass:"decrease"},[_vm._v("("+_vm._s(_vm.value)+")")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04e14695","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/reports/ReportsValueDifference.vue
// module id = 82bD
// module chunks = 0